// extracted by mini-css-extract-plugin
export default {"container":"rr-z","brandName":"sr-z","productName":"tr-z","productNamePdpEnhancements":"ur-z","breakLongProductName":"vr-z"};